import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/redeems/redeemsActions";
import { useRedeemsUIContext } from "../RedeemsUIContext";

export function RedeemIdentityDialog({ id, show, onHide, onSuccess }) {
  // Redeems UI Context
  const redeemsUIContext = useRedeemsUIContext();
  const redeemsUIProps = useMemo(() => {
    return {
      setIds: redeemsUIContext?.setIds,
      queryParams: redeemsUIContext?.queryParams,
    };
  }, [redeemsUIContext]);

  // Redeems Redux state
  const dispatch = useDispatch();
  const { isLoading, actionsLoading, redeemForEdit } = useSelector(
    (state) => ({
      isLoading: state.redeems.actionsLoading,
      redeemForEdit: state.redeems.redeemForEdit,
      actionsLoading: state.redeems.actionsLoading,
    }),
    shallowEqual
  );

  const [verificationType, setVerificationType] = useState("simple");

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    // server call for getting Redeem by id
    dispatch(actions.fetchRedeem(id));
  }, [id, dispatch]);

  const sendIdentityVerificationEmail = () => {
    // server request for sending identity verification email
    dispatch(
      actions.sendIdentityVerificationEmail(
        redeemForEdit.redeemUser,
        verificationType,
        null // callbackUrl is null as requested
      )
    ).then(() => {
      if (onSuccess) {
        onSuccess();
      } else if (redeemsUIProps.queryParams) {
        // refresh list after deletion
        dispatch(actions.fetchRedeems(redeemsUIProps.queryParams));
        // clear selections list
        redeemsUIProps.setIds([]);
      }
      // closing modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {(isLoading || actionsLoading) && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Send Identity Verification Email
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && redeemForEdit && (
          <>
            <div className="form-group">
              <label>User ID</label>
              <input
                type="text"
                className="form-control"
                value={redeemForEdit.redeemUser}
                disabled
              />
            </div>
            <div className="form-group">
              <label>Verification Type</label>
              <select
                className="form-control"
                value={verificationType}
                onChange={(e) => setVerificationType(e.target.value)}
              >
                <option value="simple">Simple</option>
                <option value="id_verification">ID Verification</option>
              </select>
            </div>
          </>
        )}
        {isLoading && <span>Sending ...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Close
          </button>
          <> </>
          <button
            type="button"
            onClick={sendIdentityVerificationEmail}
            className="btn btn-primary btn-elevate"
          >
            Send
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
